import React from "react";

const Footer: React.FC = () => {
  return (
    <div>
      <footer className="pb-4 text-center">
        <div className="container">
          <hr />
          Copyright &copy; 2003 - {new Date().getFullYear()} Star Assurance Co Ltd - SAC
        </div>
      </footer>
    </div>
  );
};

export default Footer;
